<script>
import store from "@/store";
import { getQwzyuidByOpenidAndWxappid } from '@/apis/qiweiMiniGame';
export default {
  async mounted () {
    const params = JSON.parse(localStorage.getItem('wxAuthQuery'));
    const { plan_url, wx_app_id } = this.$route.query;
    const jump_url = plan_url || params.plan_url;
    // plan_url格式: http://pop.ad.wxbz123.cn/Planlist/ad?id=67401b85c255065f305066f2
    // 上报字段格式qwzy_uid: qwzy_231321321
    if (store.getters['user/openid']) {
      getQwzyuidByOpenidAndWxappid({
        wxappid: wx_app_id,
        openid: store.getters['user/openid'],
      }).then(res => {
        const url = `${jump_url}&qwzy_uid=qwzy_${res.data.uid}`;
        window.open(url, '_self');
      }).catch(() => {
        window.open(`${jump_url}&qwzy_uid=qwzy_null`, '_self');
      })
    } else {
      window.open(`${jump_url}&qwzy_uid=qwzy_null`, '_self');
    }
  }
}
</script>